const twitterIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 41" style="enable-background:new 0 0 40 41" xml:space="preserve">
  <circle fill="none" stroke-width="2" cx="20" cy="20" r="19"/>
  <path d="m21.78 18.98 6.94-8.06h-1.64l-6.02 7-4.81-7h-5.56l7.27 10.59-7.27 8.46h1.64l6.36-7.39 5.08 7.39h5.55l-7.54-10.99zm-2.26 2.62-.73-1.06-5.86-8.39h2.53l4.73 6.77.73 1.06 6.15 8.79h-2.53l-5.02-7.17z"/>
</svg>
`

export default twitterIcon
